import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, Event } from '@angular/router';
import { filter, map, pairwise } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RouterService } from './router.service';

@Injectable({
  providedIn: 'root'
})
export class TimetrackService {
  private navigationSubject = new Subject<{ status: string, start_time: Date, end_time: Date | null, usage_time?: number, feature?: string }>();
  navigation$ = this.navigationSubject.asObservable();
  private isInitializing = true;
  

  constructor(private router: Router, private routerService:RouterService) {
    let startTime: Date = new Date();
    let feature: string;
    startTime = new Date();

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart || event instanceof NavigationEnd),
      map(event => {
          const url = (event as NavigationStart | NavigationEnd).url;
          // console.log('url', url);
          this.routerService.currentRoute.next({url:url});
          if (url === '/chat') {
            feature = 'pg_chatgpt';
          } else if (url === '/byod') {
            feature = 'pg_byod';
          } else if (url === '/translate') {
            feature = 'pg_translate';
          } else if (url === '/transcribe') {
            feature = 'pg_transcribe';
          }   else {
            feature = 'playground'; // default value if url doesn't match any of the above
          }
        return { event: event, feature: feature };
      }),
      pairwise()
    ).subscribe(([{ event: prevEvent, feature: prevFeature }, { event: currEvent, feature: currFeature }]) => {
      if (this.isInitializing) {
        this.isInitializing = false;
        return ;
      }
      if (currEvent instanceof NavigationStart) {
        const endTime = new Date();
        const usage_time = (endTime.getTime() - startTime.getTime()) / 1000;
        this.navigationSubject.next({ status: 'check-out', start_time: startTime, end_time: endTime, usage_time: usage_time, feature: prevFeature });
        startTime = new Date(); // Update startTime for the next feature
      } else if (currEvent instanceof NavigationEnd) {
        this.navigationSubject.next({ status: 'check-in', start_time: startTime, end_time: null, usage_time: 0, feature: currFeature });
      }
    });
  }
}